export default "__VITE_ASSET__BoGrH4Xb__"